export const newIntId = () => -new Date().getTime() % 2147483647;
export const newBigIntId = () => -new Date().getTime();
export const newGuidId = () => crypto.randomUUID();
